module.exports = __webpack_public_path__ + "static/media/svgsort.ecec6b8c.svg";